import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '*',
      name: 'default',
      component: () => import('@/components/index')
    },
    {
      path: '/',
      name: 'index',
      component: () => import('@/components/index')
    },
    {
      path: '/community',
      name: 'community',
      component: () => import('@/components/community')
    },
    //物业缴费
    {
      path: '/propertyPay/bill',
      name: 'propertyPayBill',
      component: () => import('@/components/propertyPay/bill')
    },
    {
      path: '/propertyPay/newBill',
      name: 'propertyPaynewBill',
      component: () => import('@/components/propertyPay/newBill')
    },
    {
      path: '/propertyPay/history',
      name: 'propertyPayHistory',
      component: () => import('@/components/propertyPay/history')
    },
    {
      path: '/propertyPay/recharge',
      name: 'propertyPayRecharge',
      component: () => import('@/components/propertyPay/recharge')
    },
    {
      path: '/propertyPay/ticketCar',
      name: 'propertyPayTicketCar',
      component: () => import('@/components/propertyPay/ticketCar')
    },
    //报事报修
    {
      path: '/repair/info',
      name: 'repairInfo',
      component: () => import('@/components/repair/info')
    },
    // 投诉建议
    {
      path: '/advise/info',
      name: 'adviseInfo',
      component: () => import('@/components/advise/info')
    },
    //通知公告
    {
      path: '/notice/list',
      name: 'noticeList',
      component: () => import('@/components/notice/list')
    },
    {
      path: '/notice/info',
      name: 'noticeInfo',
      component: () => import('@/components/notice/info')
    },
    //停车场
    {
      path: '/parking/plateNumber',
      name: 'parkingPlateNumber',
      component: () => import('@/components/parking/plateNumber')
    },
    {
      path: '/parking/pay',
      name: 'parkingPay',
      component: () => import('@/components/parking/pay')
    },
    {
      path: '/month/recharge',
      name: 'month',
      component: () => import('@/components/parking/recharge')
    },

    //个人中心
    {
      path: '/user/info',
      name: 'userInfo',
      component: () => import('@/components/user/info')
    },
    {
      path: '/user/roomList',
      name: 'userRoomList',
      component: () => import('@/components/user/roomList')
    },
    {
      path: '/user/addRoom',
      name: 'userAddRoom',
      component: () => import('@/components/user/addRoom')
    },
    {
      path: '/user/memberList',
      name: 'userMemberList',
      component: () => import('@/components/user/memberList')
    },
    {
      path: '/user/memberInfo',
      name: 'userMemberInfo',
      component: () => import('@/components/user/memberInfo')
    },
    {
      path: '/user/ownInfo',
      name: 'userOwnInfo',
      component: () => import('@/components/user/ownInfo')
    },
    {
      path: '/user/modifyMember',
      name: 'userModifyMember',
      component: () => import('@/components/user/modifyMember')
    },
    {
      path: '/user/repairList',
      name: 'userRepairList',
      component: () => import('@/components/user/repairList')
    },
    {
      path: '/user/adviseList',
      name: 'userAdviseList',
      component: () => import('@/components/user/adviseList')
    },
    {
      path: '/user/authentication',
      name: 'userAuthentication',
      component: () => import('@/components/user/authentication')
    },
    {
      path: '/user/keys',
      name: 'userKeys',
      component: () => import('@/components/acs/KeyList')
    },
    // ad
    {
      path: '/ad',
      name: 'ad',
      component: () => import('@/components/ad/ad')
    },
    {
      path: '/ad/open',
      name: 'adOpen',
      component: () => import('@/components/ad/open')
    },
    //融科
    {
      path: '/rongke/attestation',
      name: 'rongkeAttestation',
      component: () => import('@/components/rongke/attestation')
    },
    {
      path: '/rongke/attestation2',
      name: 'rongkeAttestation2',
      component: () => import('@/components/rongke/attestation2')
    },
    {
      path: '/rongke/friendly',
      name: 'rongkeFriendly',
      component: () => import('@/components/rongke/friendly')
    },
    {
      path: '/rongke/rkUser',
      name: 'rongkeRkUser',
      component: () => import('@/components/rongke/rkUser')
    },
    {
      path: '/rongke/rkMember',
      name: 'rongkeRkMember',
      component: () => import('@/components/rongke/rkMember')
    },
    {
      path: '/rongke/modifyMember',
      name: 'rongkeModifyMember',
      component: () => import('@/components/rongke/modifyMember')
    },
    // 新版人脸注册
    {
      path: '/door/owner',
      name: 'doorOwner',
      component: () => import('@/components/door/owner')
    },
    {
      path: '/door/member',
      name: 'doorMember',
      component: () => import('@/components/door/member')
    },
    {
      path: '/door/modifyMember',
      name: 'doorModifyMember',
      component: () => import('@/components/door/modifyMember')
    },
    {
      path: '/door/photo',
      name: 'doorPhoto',
      component: () => import('@/components/door/photo')
    },
    {
      path: '/door/invitation',
      name: 'invitation',
      component: () => import('@/components/door/invitation')
    },
    {
      path: '/door/qrCode',
      name: 'qrCode',
      component: () => import('@/components/door/qrCode')
    },
    //代金券
    {
      path: '/voucher/index',
      name: 'voucher',
      component: () => import('@/components/voucher/index')
    }, {
      path: '/voucher/info',
      name: 'voucherInfo',
      component: () => import('@/components/voucher/info')
    }, {
      path: '/voucher/increase',
      name: 'voucherIncrease',
      component: () => import('@/components/voucher/increase')
    },{
      path: '/voucher/receive',
      name: 'voucherReceive',
      component: () => import('@/components/voucher/receive')
    },{
      path: '/voucher/success',
      name: 'voucherSuccess',
      component: () => import('@/components/voucher/success')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js